/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_OverInputs */

const en_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event over`)
};

const es_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento terminado`)
};

const de_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung beendet`)
};

const zh_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动结束`)
};

const ar_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهت الفعالية`)
};

const fr_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement terminé`)
};

const vi_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự kiện đã kết thúc`)
};

const sw_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukio limekwisha`)
};

const th_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรมจบแล้ว`)
};

const bs_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Događaj je završen`)
};

const ja_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント終了`)
};

const ko_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 종료`)
};

const pt_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento encerrado`)
};

const it_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento concluso`)
};

const sv_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenemanget är slut`)
};

const nl_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement afgelopen`)
};

const da_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrangementet er slut`)
};

const nb_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrangementet er over`)
};

const fi_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapahtuma on päättynyt`)
};

const pl_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydarzenie zakończone`)
};

const ru_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мероприятие завершено`)
};

const tr_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik sona erdi`)
};

const hi_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम समाप्त`)
};

const id_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara selesai`)
};

const ms_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara telah tamat`)
};

const cs_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce skončila`)
};

const el_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η εκδήλωση ολοκληρώθηκε`)
};

const he_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`האירוע הסתיים`)
};

const af_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geleentheid verby`)
};

const hu_events_over = /** @type {(inputs: Events_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az esemény véget ért`)
};

/**
* | output |
* | --- |
* | "Event over" |
*
* @param {Events_OverInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_over = /** @type {((inputs?: Events_OverInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_OverInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_over(inputs)
	if (locale === "de") return de_events_over(inputs)
	if (locale === "zh") return zh_events_over(inputs)
	if (locale === "ar") return ar_events_over(inputs)
	if (locale === "fr") return fr_events_over(inputs)
	if (locale === "vi") return vi_events_over(inputs)
	if (locale === "sw") return sw_events_over(inputs)
	if (locale === "th") return th_events_over(inputs)
	if (locale === "bs") return bs_events_over(inputs)
	if (locale === "ja") return ja_events_over(inputs)
	if (locale === "ko") return ko_events_over(inputs)
	if (locale === "pt") return pt_events_over(inputs)
	if (locale === "it") return it_events_over(inputs)
	if (locale === "sv") return sv_events_over(inputs)
	if (locale === "nl") return nl_events_over(inputs)
	if (locale === "da") return da_events_over(inputs)
	if (locale === "nb") return nb_events_over(inputs)
	if (locale === "fi") return fi_events_over(inputs)
	if (locale === "pl") return pl_events_over(inputs)
	if (locale === "ru") return ru_events_over(inputs)
	if (locale === "tr") return tr_events_over(inputs)
	if (locale === "hi") return hi_events_over(inputs)
	if (locale === "id") return id_events_over(inputs)
	if (locale === "ms") return ms_events_over(inputs)
	if (locale === "cs") return cs_events_over(inputs)
	if (locale === "el") return el_events_over(inputs)
	if (locale === "he") return he_events_over(inputs)
	if (locale === "af") return af_events_over(inputs)
	if (locale === "hu") return hu_events_over(inputs)
	return en_events_over(inputs)
});